(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-game-card.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-game-card.js');

'use strict';

const {
  useEffect,
  useRef
} = React;
const {
  ReactPaper: Paper
} = svs.ui;
const {
  RibbonBanner
} = svs.ui.ReactRibbon;
const {
  clx
} = svs.components.lbUtils;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  getRetailUrl
} = svs.components.marketplace.helpers;
const {
  FractionPayment
} = svs.components.marketplace.fractionPayment;
const {
  trackEvent
} = svs.components.analytics;
const {
  showFewSharesLeftRibbon
} = svs.components.marketplace.helpers.games;
const RetailerGameCard = _ref => {
  let {
    branding,
    game,
    onClick,
    product
  } = _ref;
  const cardRef = useRef(null);
  const {
    activatedDrawId,
    buyStop,
    containerId,
    currentUserNumberOfShares,
    fractionPrice,
    groupId,
    maxFractions,
    name,
    ownerName
  } = game;
  const formatedDate = formatDate(buyStop, true, true, true);
  const formatedPrice = svs.utils.format.Currency(fractionPrice);
  const gameLink = "".concat(svs.core.urlMapping.get('marketplace')).concat(getRetailUrl(groupId, name, 'spel', containerId, activatedDrawId), "?products=").concat(product, "&returnUrl=").concat(location.href);
  const displayUserShares = () => {
    if (currentUserNumberOfShares > 0) {
      return ". Du har ".concat(currentUserNumberOfShares, " ").concat(currentUserNumberOfShares === 1 ? 'andel' : 'andelar');
    }
    return '';
  };
  useEffect(() => {
    var _document;
    const el = (_document = document) === null || _document === void 0 ? void 0 : _document.body;
    const handleClick = _ref2 => {
      var _cardRef$current;
      let {
        target
      } = _ref2;
      if ((_cardRef$current = cardRef.current) !== null && _cardRef$current !== void 0 && _cardRef$current.contains(target)) {
        onClick(groupId, activatedDrawId);
      }
    };
    el === null || el === void 0 || el.addEventListener('click', handleClick);
    return () => {
      el === null || el === void 0 || el.removeEventListener('click', handleClick);
    };
  }, [activatedDrawId, groupId, onClick]);
  const showFewSharesLeft = showFewSharesLeftRibbon(game, groupId);
  return React.createElement(Paper, {
    branding: "sport",
    className: clx('game-card', {
      ["game-card-".concat(branding)]: branding,
      'game-card-has-shares': currentUserNumberOfShares > 0
    })
  }, React.createElement("div", {
    ref: cardRef
  }, React.createElement("a", {
    className: "game-card-header-link",
    href: gameLink,
    rel: "nofollow"
  }, React.createElement("div", {
    className: "game-card-header"
  }, React.createElement("h4", {
    className: "game-card-title notranslate"
  }, name), React.createElement("p", {
    className: "game-card-contact notranslate"
  }, ownerName))), React.createElement("div", {
    className: "game-card-content"
  }, showFewSharesLeft && React.createElement(RibbonBanner, {
    "aria-live": "polite",
    direction: "right",
    role: "region",
    size: "200"
  }, "F\xE5 kvar!"), React.createElement("div", {
    className: "game-card-andel"
  }, React.createElement("h5", {
    "aria-label": "Pris per andel: ".concat(formatedPrice, " kr"),
    className: "game-card-label"
  }, "Pris per andel"), React.createElement("p", {
    "aria-hidden": true,
    className: "game-card-value game-card-share-price notranslate"
  }, "".concat(formatedPrice, " kr"))), React.createElement("div", {
    className: "game-card-row game-card-borders"
  }, React.createElement("div", {
    className: "game-card-column game-card-buy-stop"
  }, React.createElement("h5", {
    "aria-label": "K\xF6pstopp: ".concat(formatedDate),
    className: "game-card-label"
  }, "K\xF6pstopp"), React.createElement("p", {
    "aria-hidden": true,
    className: "game-card-value"
  }, formatedDate)), React.createElement("div", {
    className: "game-card-column game-card-shares-left"
  }, React.createElement("h5", {
    "aria-label": "".concat(maxFractions, " andelar").concat(displayUserShares()),
    className: "game-card-label"
  }, React.createElement("span", null, "Andelar"), currentUserNumberOfShares > 0 && React.createElement("span", {
    className: "game-card-shares-bought"
  }, "(dina)")), React.createElement("p", {
    "aria-hidden": true,
    className: "game-card-value"
  }, React.createElement("span", null, maxFractions), currentUserNumberOfShares > 0 && React.createElement("span", {
    className: "game-card-shares-bought"
  }, "(", currentUserNumberOfShares, ")"))))), React.createElement("div", {
    className: "game-card-footer"
  }, React.createElement(FractionPayment, {
    activatedDrawId: activatedDrawId,
    containerId: containerId,
    game: game,
    groupId: groupId
  }), React.createElement("a", {
    className: "btn btn-300 cta-goto-game",
    href: gameLink,
    onClick: () => {
      trackEvent({
        category: 'Andelsspel produktsida',
        action: 'CTA andelsspel',
        opt_label: 'Till spelet'
      });
    },
    rel: "nofollow"
  }, React.createElement("span", null, "Till spelet")))));
};
const RetailerGamePropType = PropTypes.shape({
  activatedDrawId: PropTypes.number,
  activatedDrawStatus: PropTypes.number,
  buyStop: PropTypes.object,
  containerId: PropTypes.number,
  currentUserNumberOfShares: PropTypes.number,
  drawCloseTime: PropTypes.string,
  drawNumber: PropTypes.number,
  fractionPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  groupId: PropTypes.number,
  maxFractions: PropTypes.number,
  name: PropTypes.string,
  ownerName: PropTypes.string,
  productId: PropTypes.number,
  productName: PropTypes.string,
  soldFractions: PropTypes.number,
  status: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  subProductId: PropTypes.number,
  templateId: PropTypes.number,
  totalBalance: PropTypes.number,
  wagerSerial: PropTypes.string
});
RetailerGameCard.defaultProps = {
  branding: 'sport'
};
setGlobal('svs.components.tipsen.RetailerGameCard', RetailerGameCard);
setGlobal('svs.components.tipsen.RetailerGamePropType', RetailerGamePropType);

 })(window);